var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 235,
    height: 250,
    viewBox: "0 0 235 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopOpacity: 0.537
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(-31.828 -108.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Controls-icon-Profile",
    transform: "translate(66.828 133.081)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2861",
    "data-name": "Group 2861"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2264",
    "data-name": "Rectangle 2264",
    width: 200,
    height: 200,
    fill: "#0098db",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2860",
    "data-name": "Group 2860",
    transform: "translate(5.263 5.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3727",
    "data-name": "Path 3727",
    d: "M107.069,12.332a94.737,94.737,0,1,0,94.737,94.737A94.842,94.842,0,0,0,107.069,12.332Zm61.578,147.719c-8.981-23.588-42.661-34.076-42.661-34.076-3.705,2.434-14.14,4.928-18.917,4.928s-15.218-2.493-18.923-4.928c0,0-33.674,10.488-42.661,34.071a81.332,81.332,0,1,1,123.161.005Z",
    transform: "translate(-12.332 -12.332)",
    fill: "#0098db"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_600",
    "data-name": "Ellipse 600",
    cx: 35.706,
    cy: 40.829,
    rx: 35.706,
    ry: 40.829,
    transform: "translate(59.029 29.969)",
    fill: "#0098db"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787",
    transform: "translate(32.328 108.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M0,69Z",
    transform: "translate(3.154 21.138)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715",
    transform: "translate(-0.5 -0.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M21.442,3.335c.963,1.25-11.111,13.7-13.254,13.555S3.122,9.925.262,13.441C-2.044,16.274,11.479,2.94,17.917.074,19.339-.56,21.255,3.093,21.442,3.335Z",
    transform: "translate(70.698 77.618) rotate(7)",
    fill: "#4d2b89"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_691",
    "data-name": "Rectangle 691",
    width: 11.595,
    height: 11.595,
    transform: "translate(38.77 41.89)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_699",
    "data-name": "Rectangle 699",
    width: 11.595,
    height: 11.595,
    transform: "translate(38.77 70.441)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_701",
    "data-name": "Rectangle 701",
    width: 11.595,
    height: 11.595,
    transform: "translate(38.77 98.989)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_703",
    "data-name": "Rectangle 703",
    width: 11.595,
    height: 11.595,
    transform: "translate(38.77 127.54)",
    fill: "#6c63ff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_468",
    "data-name": "Ellipse 468",
    cx: 39.728,
    cy: 6.381,
    rx: 39.728,
    ry: 6.381,
    transform: "translate(15.567 237.239)",
    fill: "#6639b7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M841.292,851.213s-6.523,2.4-11.008,2.7a4.188,4.188,0,0,1-4.277-2.707,8.274,8.274,0,0,1-.677-2.446l.591-6.462.31-3.437,9.528-2.479,1.35,4.13.126.31c.538,1.382,2.715,6.984,2.65,8.154a2.238,2.238,0,0,0,.665,1.631A3.783,3.783,0,0,0,841.292,851.213Z",
    transform: "translate(-798.348 -604.747)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M931.2,847.275a1.631,1.631,0,0,1-.057.587s-13.952,2.324-16.806,0a7.555,7.555,0,0,0-5.855-1.725s-5.4.147-6.3-1.631a7.065,7.065,0,0,1-.045-3.616,34.691,34.691,0,0,1,.946-3.963l.216-.171,1.284-1.031,15.037-.444h.114c-.073,3.074,5.1,6.6,5.1,6.6C930.347,843.919,931.158,846.223,931.2,847.275Z",
    transform: "translate(-843.968 -604.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M931.2,855.419a1.678,1.678,0,0,1-.061.587s-13.952,2.324-16.8,0a7.555,7.555,0,0,0-5.859-1.725s-5.4.147-6.3-1.631a7.123,7.123,0,0,1-.045-3.62c2.079.208,5.361.726,6.65,1.965,1.949,1.875,5.251,3.751,7.274,3.9C917.655,854.995,927.159,855.3,931.2,855.419Z",
    transform: "translate(-843.965 -612.24)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M842.275,871.854s-6.523,2.4-11.008,2.7a4.188,4.188,0,0,1-4.277-2.707c1.663.559,3.967,1.142,5.178.607,1.435-.64,6.523-1.048,9.378-1.223a3.7,3.7,0,0,0,.73.624Z",
    transform: "translate(-799.333 -625.388)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M873.083,374.595c-5.382-2.092-12.9-20.27-11.17-23.5a7.309,7.309,0,0,0,.673-2.593,23.683,23.683,0,0,0,.049-3.669,50.406,50.406,0,0,0-.722-5.973s16.8.379,15.823,2.854a9.184,9.184,0,0,0-.253,3.4c.082,1.407.281,3.009.493,4.359.289,1.847.587,3.262.587,3.262s2.647,5.349,2.048,5.426S880.8,377.591,873.083,374.595Z",
    transform: "translate(-819.94 -309.659)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M838.054,840.77l-.126.139c-5.023-6.075-11.1,1.5-11.1,1.5l-.09-.163.31-3.437,9.528-2.479,1.349,4.13Z",
    transform: "translate(-799.179 -604.718)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M921.436,835.684s-3.669-.073-5.626,1.655-11.416.371-11.008,0a1.411,1.411,0,0,0,.212-.624l1.284-1.032,15.036-.444C921.391,835.525,921.436,835.684,921.436,835.684Z",
    transform: "translate(-845.558 -604.072)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M878.1,341.744a9.181,9.181,0,0,0-.253,3.4A13.964,13.964,0,0,1,863,344.863a50.393,50.393,0,0,0-.722-5.973S879.082,339.269,878.1,341.744Z",
    transform: "translate(-820.3 -309.677)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M838.27,652.556a11.437,11.437,0,0,0-.62,2.092,23.932,23.932,0,0,0-.281,5.936c.151,2.854,0,21.98,0,21.98a58.2,58.2,0,0,1-5.027,6.9c-1.8,1.8,3.669,5.027,3.669,5.027.815,4.652-4.126,9.9-4.126,9.9-5.023-6.075-11.1,1.5-11.1,1.5s-3.3-5.708-4.126-7.747,3.225-3.445,4.648-4.277-.073-5.708-.073-5.708-1.2-4.277-2.626-8.179,1.574-23.321,1.574-23.321.155-19.6.526-20.8a20.8,20.8,0,0,0,0-4.3c-.024-.3.02-3.327,0-3.5s-.526-3.471-.526-3.471l.526-6.339-.526-7.384s21.327-10.528,26.674,1.515c1.462,3.294,2.093,11.1,0,19.177C844.242,641.649,838.482,652.036,838.27,652.556Z",
    transform: "translate(-793.158 -468.65)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M910.587,709s-3.669-.077-5.626,1.631-11.416.375-11.008,0,.371-3.148.371-3.148c-5.549-7.579-.815-10.654-.815-10.654s-2.475-11.926-2.923-16.349c-.314-3.086-.7-11.416-.909-16.133-.09-2.039-.143-3.445-.143-3.445l.143-6.261-.143-14.679L886.471,622.1h24.116v5.19l-1.24,4.415v8.253l-1.631,6.171V651.8l-2.173,5.89s.3,2.039.506,3.706a16.292,16.292,0,0,1,.167,2.149c-.069.815,0,3.372,0,3.372l.375,7.649a8.828,8.828,0,0,0-.375,2.475c.077.979,1.5,14.926,1.5,14.926s2.475,8.326,1.631,8.925S910.587,709,910.587,709Z",
    transform: "translate(-834.698 -477.834)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M1.079,0H52.011l-.765,4.356V6.931H2.595V3.524Z",
    transform: "translate(24.676 140.554)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M876.476,303.542a13.949,13.949,0,1,1-27.9.334c0-.114,0-.22,0-.334a13.952,13.952,0,1,1,27.9,0Z",
    transform: "translate(-812.189 -280.477)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M874.561,391.5c-5.382-2.092-14.327-21.742-12.6-24.972a2.969,2.969,0,0,0,.518-1.615l5.6,9.345,6.031,9.506,3.913-18.851c.29,1.847.587,3.262.587,3.262s3.156,3.926,2.557,4S882.283,394.493,874.561,391.5Z",
    transform: "translate(-819.991 -325.162)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M835.645,408.713v45.694l-49.274-.92-1.534-3.238V435.1l-1.431-48.38h-5.253l-7.856.679.886-3.411,3.74-4.685,3.9-4.588-3.9-2.061v-2.989l1.244-6.252,2.654-2.871,2.975-2.406,4.461-2.591,3.752-1.6,4.567-.867,2.775-1.151,2.553-.895h1.6l3.947,7.1,8.05,12.778,1.861-8.456,2.108-10.526,3.068,1.151,3.5.867,2.645.465,3.949.689,5.008,3.031,1.684,1.654,1.154,1.6.934,2.024L841,366.693l.64,2.968,1.183,5.05,1.114,2.624,1.05,1.964,1.211,2.2.689,2.482.663,3.411-.663,2.2Z",
    transform: "translate(-759.128 -309.419)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M844.3,707.67a11.42,11.42,0,0,0-.62,2.092,59.117,59.117,0,0,1-16.839-5.255l-.11-.057.037-.656v-.342l2.039-3.8S845.277,705.276,844.3,707.67Z",
    transform: "translate(-799.182 -523.654)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M923.339,713.106a68,68,0,0,1-16.785,1.072l-.084-2.581,16.124-2.2S923.021,711.422,923.339,713.106Z",
    transform: "translate(-851.546 -527.714)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M826.547,563.059c.224,0,11.624-1.2,11.624-1.2s6.9,13.577,6.45,16.875-1.272,6.226-4.049,5.708-14.943.408-14.943.408Z",
    transform: "translate(-798.531 -441.957)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M825.437,560.849c.228,0,11.628-1.2,11.628-1.2s6.9,13.6,6.45,16.859-1.276,6.226-4.049,5.708-14.947.408-14.947.408Z",
    transform: "translate(-797.872 -440.647)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M838.784,547s10.462,5.626,10.686,7.339-5.325-.75-6.523-1.052a15.567,15.567,0,0,0-2.4-.375l-8,.216.909-3.915L836.173,547Z",
    transform: "translate(-802.639 -433.132)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M876.476,303.542a13.905,13.905,0,0,1-.685,4.326.579.579,0,0,1-.44-.106c-.11-3.669-1.912-7.119-4.134-10.05a10.646,10.646,0,0,0-2.242-2.324,4.392,4.392,0,0,0-3.042-.86c-1.223.167-2.3,1-3.539,1.1-1.631.135-3.09-.995-4.709-1.048a4.615,4.615,0,0,0-3.462,1.606,9.443,9.443,0,0,0-1.855,3.437,20.132,20.132,0,0,0-1.036,5.936c-.02,1.142-.13,2.573-1.19,2.989A6.075,6.075,0,0,0,848.6,303.9l-.024-.029v-.334a13.952,13.952,0,0,1,27.9,0Z",
    transform: "translate(-812.189 -280.477)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M862.413,268.153a9.606,9.606,0,0,0-6.776-.53c-1.129.334-2.194.877-3.339,1.15a20.006,20.006,0,0,0-6.866,2.629,9.216,9.216,0,0,0-2.724,3.321l-.958,3.237A13.86,13.86,0,0,0,840.4,282.5c-.371,1.871-.807,3.768.38,5.277.86,1.093.995,1.393,1.932,2.425a6.115,6.115,0,0,1,1.533,4.66c1.06-.408,1.166-1.847,1.19-2.989a20.159,20.159,0,0,1,1.036-5.936,9.443,9.443,0,0,1,1.855-3.437,4.619,4.619,0,0,1,3.461-1.611c1.631.057,3.095,1.186,4.709,1.048,1.223-.1,2.308-.934,3.539-1.1a4.37,4.37,0,0,1,3.042.86,10.445,10.445,0,0,1,2.238,2.324c2.226,2.936,4.032,6.368,4.138,10.05.461.334,1.125-.106,1.354-.628a14.922,14.922,0,0,1,.526-1.631c.334-.575.455-2.156.957-2.588a12.7,12.7,0,0,0,.519-3.568,15.5,15.5,0,0,1,.567-3.156c.192-1.007-.69-3-1.424-4.178s-.666-2.844-1.809-3.6a8.72,8.72,0,0,1-3.617-2.822,15.945,15.945,0,0,0-1.712-2.1C864.586,269.588,862.413,268.242,862.413,268.153Z",
    transform: "translate(-806.282 -267.239)",
    fill: "#512e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M937.3,565.077c.815.991.3,5.443.3,5.443l-2.251,3.722s.135,2.406.143,5.651l-3.784,1.182a2.251,2.251,0,0,1-2.919-2.218l.656-21.038,8.827,3.372c-.75.522.073,1.8.073,1.8S936.474,564.087,937.3,565.077Z",
    transform: "translate(-859.791 -439.562)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M7.063,3.283s-.6,3.828-2.1,4.053S2.79,13.529,1.294,13.321.788,7.768.841,6.732-.789,1.408.466.433s5.251,0,5.251,0Z",
    transform: "translate(73.225 111.413) rotate(3)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M834.92,822.535s3.939-2.475,6.523-.677S834.92,822.535,834.92,822.535Z",
    transform: "translate(-804.032 -595.759)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M910,805.668a7.973,7.973,0,0,1,6.413,2.7C919.341,811.523,910,805.668,910,805.668Z",
    transform: "translate(-848.625 -586.544)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    transform: "translate(33.938 15.926)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M841.162,312.452c-.656-1.032-1.555-1.725-2.159-2.817a7.632,7.632,0,0,1-.833-3.335,8.328,8.328,0,0,0,.833,4.236c.6,1.093,1.5,1.782,2.159,2.813a7.627,7.627,0,0,1,1.082,3.637A7.88,7.88,0,0,0,841.162,312.452Z",
    transform: "translate(-838.155 -306.3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M938.409,563.971c.815.987.3,5.439.3,5.439l-2.242,3.726s.135,2.4.147,5.647l-3.853,1.2a2.2,2.2,0,0,1-2.854-2.165l.656-21.111,8.823,3.38c-.754.522.069,1.8.069,1.8S937.586,562.981,938.409,563.971Z",
    transform: "translate(-860.456 -438.904)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M4.155,36.047l.851-19.638L0,1.267,14.123,0l2.292,14.061-9,24.161Z",
    transform: "translate(73.036 75.358) rotate(3)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M6.041,2.176l4.234,23.4L0,43.8,15.576,48.06l5.4-17.038.53-4.51L20.159,22.04,10.283,0Z",
    transform: "translate(40.524 116.557) rotate(161)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M3.921,3.862,4.432,0l6.112,3.909S23.19,25.443,24.153,26.632s-6.745,4.1-8.889,3.959S11.1,37.775,8.239,41.119.022,21.195,0,20.788,3.182,9.333,3.182,9.333Z",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 74.59, 50.339)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M5.073,35.764,8.2,34.074l2.374-2.618s12.6-21.08,13.558-22.243S20.12,4.23,17.977,4.369,5.413,3.685,2.546.41.025,14.529,0,14.928s3.2,11.216,3.2,11.216Z",
    transform: "matrix(-0.966, 0.259, -0.259, -0.966, 32.689, 85.599)",
    fill: "#6639b7"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.9b10a179cd5321d1d21216a278d9d220.svg";
export { ForwardRef as ReactComponent };